import { InputSave } from '../../assets/scripts/vendor/input-save.min';
import { MOBILE } from '../../assets/scripts/constants';

const CURRENCY = '₽';

const formatNumber = (value) => String(value).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
const getDigits = (value) => String(value).replace(/\D/g, '').replace(/^0+/, '');

class CertificateCheckout {
	constructor() {
		this.container = document.querySelector('[data-certificate-checkout]');

		if (!this.container) return;

		this.mm = window.matchMedia(MOBILE);
		this.input = this.container.querySelector('[data-certificate-checkout-input]');
		this.inputContainer = this.input?.closest('.input');
		this.price = this.container.querySelector('[data-certificate-checkout-price]');
		this.nominals = this.container.querySelectorAll('[data-certificate-checkout-nominal]');
		this.tags = this.container.querySelectorAll('[data-certificate-checkout-tag]');
		this.tags.forEach((tag) => {
			tag.dataset.defaultText = tag.textContent;
		});

		if (this.input) {
			this.inputSave = new InputSave();
		}

		this.value = getDigits(this.input?.value || '');

		this.init();
	}

	init() {
		document.querySelectorAll('[data-certificate-points-skip]').forEach((button) => {
			button.addEventListener('click', () => this.setStep(2));
		});

		this.container.querySelectorAll('[data-certificate-checkout-back]').forEach((button) => {
			button.addEventListener('click', (e) => {
				e.preventDefault();
				this.setStep(1);
			});
		});

		this.nominals.forEach((button) => {
			button.addEventListener('click', () => {
				this.setValue(button.dataset.certificateCheckoutNominal);
			});
		});

		if (this.input) {
			this.input.addEventListener('focus', () => {
				this.input.value = this.value ? formatNumber(this.value) : '';
			});

			this.input.addEventListener('input', (e) => {
				if (!e.isTrusted) return;

				this.value = getDigits(this.input.value);
				this.input.value = formatNumber(this.value);
				this.update();
			});

			this.input.addEventListener('blur', () => {
				this.input.value = this.getFormattedValue();
				this.inputContainer?.classList.toggle('_has-value', Boolean(this.value));
			});

			this.input.value = this.getFormattedValue();
			this.inputContainer?.classList.toggle('_has-value', Boolean(this.value));
		}

		this.update();
	}

	setStep(step) {
		this.container.dataset.step = step;
		this.update();

		if (this.mm.matches) {
			window.scrollTo({ top: 0 });
		}
	}

	setValue(value) {
		this.value = getDigits(value);

		if (this.input) {
			this.input.value = this.getFormattedValue();
			this.inputContainer?.classList.toggle('_has-value', Boolean(this.value));
			this.input.dispatchEvent(new Event('input', { bubbles: true }));
		}

		this.update();
	}

	getFormattedValue() {
		return this.value ? `${formatNumber(this.value)} ${CURRENCY}` : '';
	}

	update() {
		this.nominals.forEach((button) => {
			button.classList.toggle('_active', button.dataset.certificateCheckoutNominal === this.value);
		});

		this.tags.forEach((tag) => {
			tag.classList.toggle('_error', !this.value);
			tag.textContent = this.value ? tag.dataset.defaultText : tag.dataset.errorText;
		});

		if (!this.price) return;

		const isNominalStep = this.container.dataset.step === '2';

		if (!isNominalStep) {
			this.price.textContent = this.price.dataset.empty;
			return;
		}

		this.price.textContent = this.value ? this.getFormattedValue() : `0 ${CURRENCY}`;
	}
}

export default new CertificateCheckout();
